module.exports = __webpack_public_path__ + "static/media/invest-19-logo2.82f67fa8.svg";